import { createActivityStore } from "@/app/activity/store"
import { getActivityColor } from "@/app/activity/list/utils"

import Chip from "@/components/chip/Chip"
import { ActivityType } from "@/types/activity"
import { useTranslation } from "react-i18next"

import "./activityInfo.scss"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns"
import { useStadiumInfoQuery } from "@/hooks/api/useStadiumQuery"
import BasicButton from "@/components/button/BasicButton"
import { HOUR_TO_SECOND_FORMAT } from "@/constants/regex"
import { DATE_FORMAT } from "@/constants/date"
import { ActivityDeviceInfoProps } from "@/app/activity/detail/activityInfo/type"
import { Stadium } from "@/types/stadium"

export default function ActivityDeviceInfo({
  isCropping = false,
  onEditClick,
}: ActivityDeviceInfoProps) {
  const { t } = useTranslation()
  const { activity } = createActivityStore((state) => ({
    activity: state.tempActivity,
  }))

  const [stadium, setStadium] = useState<Stadium | null>(null)
  const { data: stadiumInfo } = useStadiumInfoQuery(activity?.idfStadium as number)

  const activityDate = useMemo(() => {
    if (!activity || !activity.dateStart) {
      return ""
    }

    const date = new Date(activity.dateStart)

    return format(date, DATE_FORMAT)
  }, [activity])

  const activityDuration = useMemo(() => {
    if (!activity || !activity.dateStart || !activity.dateFinish) {
      return ""
    }

    const dateStart = new Date(activity.dateStart)
    const dateFinish = new Date(activity.dateFinish)

    if (isNaN(dateStart.getTime()) || isNaN(dateFinish.getTime())) {
      return ""
    }

    return `${format(dateStart, HOUR_TO_SECOND_FORMAT)} - ${format(dateFinish, HOUR_TO_SECOND_FORMAT)}`
  }, [activity])

  useEffect(() => {
    if (stadiumInfo) {
      setStadium(stadiumInfo)
    }
  }, [stadiumInfo])

  return (
    <div className="ActivityDeviceInfoCont">
      <div className="activity-info">
        <h3>{activity?.name}</h3>
        <div className="activity-info-detail">
          <div className="activity-type-match-day">
            <p className="activity-type">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none">
                <circle cx="4" cy="4.5" r="4" fill={getActivityColor(activity?.type as string)} />
              </svg>
              {t(ActivityType[activity?.type as keyof typeof ActivityType])}
            </p>
            <Chip label={activity?.matchDay || ""} type="default-small" />
          </div>
          <p>{activityDate}</p>
          <p>{activityDuration}</p>
          <p>
            {activity?.playerCount} {t("player")}
          </p>
          <p>{stadium ? stadiumInfo?.name : "-"}</p>
        </div>
      </div>
      <BasicButton size="xs" type="default-outlined" onClick={onEditClick} disabled={isCropping}>
        {t("button.edit")}
      </BasicButton>
    </div>
  )
}
